export default {
  creatTs: {
    label: 'delimit.report.table.requestDate',
    type: 'datetime',
    field: 'creatTs',
    align: 'left',
    customWidth: 180,
    render: true,
    fixed: true,
  },
  branch: {
    label: 'delimit.report.table.store',
    field: 'branch',
    type: 'general',
    align: 'left',
    customWidth: 150,
    fixed: true,
    render: true,
  },
  lmCode: {
    label: 'lm_label',
    field: 'lmCode',
    type: 'general',
    align: 'left',
    customWidth: 85,
    fixed: true,
    render: true,
    disableOrder: true,
  },
  productName: {
    label: 'reports.description',
    field: 'productName',
    type: 'general',
    align: 'left',
    customWidth: 225,
    fixed: true,
    render: true,
  },
  section: {
    label: 'delimit.report.table.section',
    field: 'section',
    type: 'general',
    align: 'left',
    customWidth: 148,
    fixed: false,
    render: true,
    disableOrder: true,
  },
  quantity: {
    label: 'order.quantity_label',
    field: 'quantity',
    type: 'decimal2',
    align: 'left',
    customWidth: 120,
    fixed: false,
    render: true,
    disableOrder: true,
  },
  cmup: {
    label: 'delimit.report.table.cmup',
    field: 'cmup',
    type: 'null-currency',
    align: 'left',
    customWidth: 150,
    fixed: false,
    render: true,
    disableOrder: true,
  },
  tipStatus: {
    label: 'delimit.report.table.statusType',
    field: 'tipStatus',
    type: 'general',
    align: 'left',
    customWidth: 100,
    fixed: false,
    render: true,
    disableOrder: true,
  },
  requester: {
    label: 'delimit.report.table.requester',
    field: 'requester',
    type: 'general',
    align: 'left',
    customWidth: 180,
    fixed: false,
    render: true,
    disableOrder: true,
  },
  approver: {
    label: 'delimit.report.table.approver',
    field: 'approver',
    type: 'general',
    align: 'left',
    customWidth: 180,
    fixed: false,
    render: true,
    disableOrder: true,
  },
  dthApproved: {
    label: 'delimit.report.table.dthApproved.new',
    field: 'dthApproved',
    type: 'datetime',
    align: 'left',
    customWidth: 180,
    fixed: false,
    render: true,
    disableOrder: true,
  },

  quantityApproved: {
    label: "delimit.report.table.qtyApproved",
    field: "quantityApproved",
    type: 'general',
    align: "left",
    customWidth: 230,
    fixed: false,
    render: true,
    disableOrder: true,
  },

  valueApproved: {
    label: "delimit.report.table.valueApproved",
    field: "valueApproved",
    type: 'null-currency',
    align: "left",
    customWidth: 230,
    fixed: false,
    render: true,
    disableOrder: true,
  },

  justifyName: {
    label: 'delimit.report.table.txtResponseCreate',
    field: 'justifyName',
    type: 'general',
    align: 'left',
    customWidth: 230,
    fixed: false,
    render: true,
    disableOrder: true,
  },
  reproveReason: {
    label: 'demarcate.report.table.reproveReason',
    field: 'reproveReason',
    type: 'general',
    align: 'left',
    customWidth: 230,
    fixed: false,
    render: true,
    disableOrder: true,
  },
  depositOrigin: {
    label: 'delimit.report.table.depositOrigin',
    field: 'depositOrigin',
    type: 'general',
    align: 'left',
    customWidth: 180,
    fixed: false,
    render: true,
    disableOrder: true,
  },
  revenuesLdap: {
    label: 'delimit.report.table.revenueLdap',
    field: 'revenuesLdap',
    type: 'general',
    align: 'left',
    customWidth: 180,
    fixed: false,
    render: true,
    disableOrder: true,
  },
  billingTimestamp: {
    label: 'delimit.report.table.invoiceTimestamp',
    field: 'billingTimestamp',
    type: 'datetime',
    align: 'left',
    customWidth: 200,
    fixed: false,
    render: true,
    disableOrder: true,
  },
  billingNumber: {
    label: 'delimit.report.table.invoiceNumber.new',
    field: 'billingNumber',
    type: 'general',
    align: 'left',
    customWidth: 200,
    fixed: false,
    render: true,
    disableOrder: true,
  },
  nfValue: {
    label: 'delimit.report.table.nfValue',
    field: 'nfValue',
    type: 'general',
    align: 'left',
    customWidth: 200,
    fixed: false,
    render: true,
    disableOrder: true,
  },
  userObservation: {
    label:"Observação",
    field: "userObservation",
    type: "general",
    align: "left",
    customWidth: 150,
    fixed: false,
    render: true,
    disableOrder: true
  }
}
